export const CLASS_NAMES = {
  section: 'flex flex-1 flex-row mt-20',
  side: 'w-64 flex flex-col mr-20',
  content: 'min-w-96 flex flex-1 flex-col gap-y-4',
  container: 'flex flex-col w-full max-w-180 text-left',
  footer: 'flex flex-end w-full max-w-256 justify-end p-10 mx-auto',
};
